import { render } from "./Footer.vue?vue&type=template&id=68ac08ae&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=68ac08ae&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-68ac08ae"

export default script